import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

import AddressDisplay from "~/components/address/AddressDisplay.tsx";
import ButtonNewItem from "~/components/buttons/ButtonNewItem/ButtonNewItem";
import Card from "~/components/Card/Card";
import CardValue from "~/components/Card/components/CardValue.tsx";
import ContentWrapper from "~/components/ContentWrapper";
import LoadingSpinnerFull from "~/components/LoadingSpinners/LoadingSpinnerFull";
import CreateOrUpdateSellerProfileSidebar
	from "~/modules/admin/components/AdminView/components/AdminSellerProfileSection/components/CreateOrUpdateSellerProfileSidebar/CreateOrUpdateSellerProfileSidebar.tsx";
import { sellerProfileQueries } from "~/modules/billing/sellerProfile/sellerProfileQueries.ts";

type Props = {
	userCanManageSellerProfile: boolean;
}

const AdminSellerProfileSection = ({ userCanManageSellerProfile }: Props) => {
	const [showForm, setShowForm] = useState<boolean>(false);
	const { data, isLoading } = useQuery(sellerProfileQueries.details());

	return <ContentWrapper className="relative w-full overflow-hidden pb-10 pt-4">
		{isLoading && <LoadingSpinnerFull />}
		{!isLoading && !data &&
			<ButtonNewItem onClick={userCanManageSellerProfile ? () => setShowForm(true) : ()=>{}}>Es sind noch keine
				Profildaten vorhanden. Klicke hier, um
				sie zu erstellen.</ButtonNewItem>}
		{!isLoading && data && <Card title="Profildaten"
									 onHeaderButtonClick={userCanManageSellerProfile?() => setShowForm(true): ()=>{}}
									 headerButtonText={userCanManageSellerProfile ? "Bearbeiten": undefined}>
			<div className="grid grid-cols-3 gap-x-8">
				<div className="space-y-4">
					<CardValue label="Name Legaleinheit">
						{data.name}
					</CardValue>
					<CardValue label="Adresse">
						<AddressDisplay address={data.address} />
					</CardValue>
					<CardValue label="Umsatzsteuer-ID">
						{data.vatIdentifier}
					</CardValue>
					<CardValue label="Elektronische Adresse (E-Mail)">
						{data.electronicAddress}
					</CardValue>
				</div>
				<div className="space-y-4">
					<CardValue label="Bankname">
						{data.bankName}
					</CardValue>
					<CardValue label="IBAN">
						{data.bankIban}
					</CardValue>
					<CardValue label="BIC">
						{data.bankBic}
					</CardValue>
				</div>
				<div className="space-y-4">
					<CardValue label="Kontakt Name">
						{data.contactName}
					</CardValue>
					<CardValue label="Kontakt Telefon">
						{data.contactPhone}
					</CardValue>
					<CardValue label="Kontakt E-Mail">
						{data.contactEmail}
					</CardValue>
				</div>
			</div>
		</Card>}
		<CreateOrUpdateSellerProfileSidebar isOpen={showForm}
											onClose={() => setShowForm(false)}
											sellerProfile={data} />
	</ContentWrapper>;
};

export default AdminSellerProfileSection;